import { upperFirst } from 'lodash';
import { Control, Controller, FormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SurveyScoreInformation } from '../../../shared/helpers/surveyScoreInformation';
import SurveyErrorMessage from '../SurveyErrorMessage';
import { SurveyAnswerForm } from '../SurveyForm/SurveyForm.types';
import {
  StyledScoreCard,
  StyledScoreContainer,
  StyledScoreDescriptionContainer,
  StyledScoreDescriptionText,
} from './SurveyScore.styles';

const SurveyScore = ({
  control,
  formState,
}: {
  control: Control<SurveyAnswerForm>;
  formState: FormState<SurveyAnswerForm>;
}) => {
  const { t } = useTranslation(['survey']);
  const defaultFormErrorLabel = t('survey:surveyErrorMessage');

  return (
    <div>
      <StyledScoreContainer>
        <Controller
          control={control}
          name="grade"
          rules={{
            required: defaultFormErrorLabel,
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <>
              {SurveyScoreInformation.map((score, index) => (
                <StyledScoreCard
                  color={score.color}
                  key={`score-card-${index}`}
                  onClick={e => {
                    e.preventDefault();
                    onChange(score.value);
                  }}
                  aria-pressed={value === score.value}
                >
                  {score.label}
                </StyledScoreCard>
              ))}
              <StyledScoreDescriptionContainer>
                <StyledScoreDescriptionText>
                  {upperFirst(t('survey:surveyLikely'))}
                </StyledScoreDescriptionText>
                <StyledScoreDescriptionText>
                  {upperFirst(t('survey:surveyNotLikely'))}
                </StyledScoreDescriptionText>
              </StyledScoreDescriptionContainer>
              {formState.errors.grade && (
                <SurveyErrorMessage message={error?.message || ''} />
              )}
            </>
          )}
        />
      </StyledScoreContainer>
    </div>
  );
};

export default SurveyScore;
